// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Ipip","footer":"ModalCreateQualiphyProcedure_footer__3y6uQ","additionData":"ModalCreateQualiphyProcedure_additionData__3dxnU"};